require('./bootstrap');
require('./jquery');

import Flash from './components/Flash';
import AlgoliaAutocomplete from './components/AlgoliaAutocomplete';
import ArchiveInstitution from "./components/ArchiveInstitution";
import CourseRating from './components/CourseRating';
import RegistrationForm from './components/RegistrationForm';
import InstitutionUsers from './components/InstitutionUsers';
import EditUser from "./components/EditUser";
import UserInstitutions from "./components/UserInstitutions";
import OrderStatusForManager from "./components/OrderStatusForManager";
import OrderStatusForInstitution from "./components/OrderStatusForInstitution";
import OrderNoteForInstitution from "./components/OrderNoteForInstitution";
import OrdersDateRange from "./components/OrdersDateRange";
import StatsMonthlyRange from "./components/StatsMonthlyRange";
import InstitutionLocationPicker from "./components/InstitutionLocationPicker";
import Map from "./components/Map";
import ImportInstitutionStatus from "./components/ImportInstitutionStatus";
import ImportScheduledForm from "./components/ImportScheduledForm";
import ImportForm from "./components/ImportForm";
import Tooltip from 'tooltip.js';

Vue.component('flash', Flash);
Vue.component('algolia-autocomplete', AlgoliaAutocomplete);
Vue.component('course-rating', CourseRating);
Vue.component('registration-form', RegistrationForm);
Vue.component('institution-users', InstitutionUsers);
Vue.component('user-institutions', UserInstitutions);
Vue.component('archive-institution', ArchiveInstitution);
Vue.component('edit-user', EditUser);
Vue.component('order-status-for-manager', OrderStatusForManager);
Vue.component('order-status-for-institution', OrderStatusForInstitution);
Vue.component('order-note-for-institution', OrderNoteForInstitution);
Vue.component('orders-date-range', OrdersDateRange);
Vue.component('stats-monthly-range', StatsMonthlyRange);
Vue.component('institution-location-picker', InstitutionLocationPicker);
Vue.component('show-map', Map);
Vue.component('import-institution-status', ImportInstitutionStatus);
Vue.component('import-form', ImportForm);
Vue.component('schedule-import-form', ImportScheduledForm);

Vue.directive('tooltip', {
    bind(el, bindings) {
        new Tooltip(el, {
            placement: bindings.arg || 'bottom',
            title: bindings.value,
            template: '<div class="tooltip-custom" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        });
    }
});

new Vue({
    el: '#app',

    data() {
        return {
            moment: window.moment,
            isLoading: false,
        }
    },

    created() {
        this.setupAxios();
    },

    mounted() {
        document.querySelectorAll('[data-tooltip]').forEach(el => {
            new Tooltip(el, {
                placement: el.dataset.tooltipPlacement || 'top',
                title: el.dataset.tooltip,
                template: '<div class="tooltip-custom" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
            });
        });
    },

    methods: {
        onPageChange() {
            window.scrollTo(0,0);
        },

        setupAxios() {
            axios.interceptors.request.use(config => {
                this.isLoading = true;
                return config;
            }, error => {
                this.isLoading = false;
                return Promise.reject(error);
            });

            axios.interceptors.response.use(response => {
                this.isLoading = false;
                return response;
            }, error => {
                this.isLoading = false;
                return Promise.reject(error);
            });
        }
    },

    filters: {
        truncate: function (string, limit, end = '...') {
            return string.substring(0, limit) + end;
        },
        striphtml: function (value) {
            let div = document.createElement('div');
            div.innerHTML = value;
            return div.textContent || div.innerText || '';
        }
    }
});
